/* unplugin-vue-components disabled */import { render } from "./topic-item.vue?vue&type=template&id=92a3c03c&scoped=true"
import script from "./topic-item.vue?vue&type=script&lang=js"
export * from "./topic-item.vue?vue&type=script&lang=js"

import "./topic-item.vue?vue&type=style&index=0&id=92a3c03c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a3c03c"],['__file',"src/pages/pulse/tracker/topic-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92a3c03c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92a3c03c', __exports__)) {
    api.reload('92a3c03c', __exports__)
  }
  
  module.hot.accept("./topic-item.vue?vue&type=template&id=92a3c03c&scoped=true", () => {
    api.rerender('92a3c03c', render)
  })

}


export default __exports__